<template>
  <div id="special">
    <div class="content">
      <div class="card">
        <div class="top" @click="flag5 = !flag5">
          <div class="title">
            <img src="../../../assets/htImg/icon_shengxiang.png" alt="" />
            <span>声像资料（含电子数据）专业委员会</span>
          </div>
          <img :src="flag5 ? open : shut" alt="" />
        </div>
        <div class="bottom" v-if="flag5">
          <elmTable :tableData="tableList.tableData8" />
        </div>
      </div>
      <div class="card">
        <div class="top" @click="flg3 = !flg3">
          <div class="title">
            <img
              style="width: 24px;"
              src="../../../assets/htImg/icon_wenjian.png"
              alt=""
            />
            <span>文检专业委员会</span>
          </div>
          <img :src="flg3 ? open : shut" alt="" />
        </div>
        <div class="bottom" v-if="flg3">
          <elmTable :tableData="tableList.tableData5" />
        </div>
      </div>
      <div class="card">
        <div class="top" @click="flg4 = !flg4">
          <div class="title">
            <img
              style="width: 25px;"
              src="../../../assets/htImg/icon_huanshun.png"
              alt=""
            />
            <span>环损专业委员会</span>
          </div>
          <img :src="flg4 ? open : shut" alt="" />
        </div>
        <div class="bottom" v-if="flg4">
          <elmTable :tableData="tableList.tableData7" />
        </div>
      </div>
      <div class="card">
        <div class="top" @click="flag3 = !flag3">
          <div class="title">
            <img src="../../../assets/htImg/icon_henji.png" alt="" />
            <span>痕迹专业委员会</span>
          </div>
          <img :src="flag3 ? open : shut" alt="" />
        </div>
        <div class="bottom" v-if="flag3">
          <elmTable :tableData="tableList.tableData4" />
        </div>
      </div>
      <div class="card">
        <div class="top" @click="flag4 = !flag4">
          <div class="title">
            <img src="../../../assets/htImg/icon_jiaotong.png" alt="" />
            <span>交通专业委员会</span>
          </div>
          <img :src="flag4 ? open : shut" alt="" />
        </div>
        <div class="bottom" v-if="flag4">
          <elmTable :tableData="tableList.tableData6" />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="card">
        <div class="top" @click="flg2 = !flg2">
          <div class="title">
            <img
              style="width: 21px;"
              src="../../../assets/htImg/icon_lihua.png"
              alt=""
            />
            <span>理化（毒品毒物、微量物证）专业委员会</span>
          </div>
          <img :src="flg2 ? open : shut" alt="" />
        </div>
        <div class="bottom" v-if="flg2">
          <elmTable :tableData="tableList.tableData3" />
        </div>
      </div>
      <div class="card">
        <div class="top" @click="flag2 = !flag2">
          <div class="title">
            <img src="../../../assets/htImg/icon_fayiwuzheng.png" alt="" />
            <span>法医物证专业委员会</span>
          </div>
          <img :src="flag2 ? open : shut" alt="" />
        </div>
        <div class="bottom" v-if="flag2">
          <elmTable :tableData="tableList.tableData2" />
        </div>
      </div>
      <div class="card">
        <div class="top" @click="flg5 = !flg5">
          <div class="title">
            <img
              style="width: 22px;"
              src="../../../assets/htImg/icon_zhishichanquan.png"
              alt=""
            />
            <span>知识产权专业委员会</span>
          </div>
          <img :src="flg5 ? open : shut" alt="" />
        </div>
        <div class="bottom" v-if="flg5">
          <elmTable :tableData="tableList.tableData9" />
        </div>
      </div>
      <div class="card">
        <div class="top" @click="flag = !flag">
          <div class="title">
            <img src="../../../assets/htImg/icon_fayixue.png" alt="" />
            <span>法医学专业委员会</span>
          </div>
          <img :src="flag ? open : shut" alt="" />
        </div>
        <div class="bottom" v-if="flag">
          <elmTable :tableData="tableList.tableData0" />
        </div>
      </div>
      <div class="card">
        <div class="top" @click="flg = !flg">
          <div class="title">
            <img src="../../../assets/htImg/icon_jingshenbing.png" alt="" />
            <span>精神病专业委员会</span>
          </div>
          <img :src="flg ? open : shut" alt="" />
        </div>
        <div class="bottom" v-if="flg">
          <elmTable :tableData="tableList.tableData1" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import elmTable from "../../common/elmTable";
import { committeeData } from "../../../api/backstage";
export default {
  components: {
    elmTable,
  },
  data() {
    return {
      flag: false,
      flag2: false,
      flag3: false,
      flag4: false,
      flag5: false,
      flg: false,
      flg2: false,
      flg3: false,
      flg4: false,
      flg5: false,
      cartIndex: 0,
      open: require("../../../assets/htImg/icon_zhankai.png"), // 开
      shut: require("../../../assets/htImg/icon_shouqi.png"), //关
      tableList: {
        tableData0: [],
        tableData1: [],
        tableData2: [],
        tableData3: [],
        tableData4: [],
        tableData5: [],
        tableData6: [],
        tableData7: [],
        tableData8: [],
        tableData9: [],
      },
    };
  },
  created() {
    committeeData().then((res) => {
      if (res.code == 1) {
        this.tableList.tableData0 = res.list0;
        this.tableList.tableData1 = res.list1;
        this.tableList.tableData2 = res.list2;
        this.tableList.tableData3 = res.list3;
        this.tableList.tableData4 = res.list4;
        this.tableList.tableData5 = res.list5;
        this.tableList.tableData6 = res.list6;
        this.tableList.tableData7 = res.list7;
        this.tableList.tableData8 = res.list8;
        this.tableList.tableData9 = res.list9;
      } else if (res.code == 1001) {
        this.$alert("请先登录", "警告", {
          confirmButtonText: "确定",
          type: "warning",
          callback: () => {
            this.$router.push("/login");
          },
        });
      } else if (res.code == -1) {
        this.$message.error("数据异常");
      }
    });
  },
  methods: {},
};
</script>

<style scoped lang="less">
#special {
  width: 100%;
  display: flex;
  justify-content: space-around;
  .content {
    margin-top: 58px;
    .card {
      width: 688px;
      margin-bottom: 20px;
      border-radius: 4px;
      border: 1px solid #cacaca;
      .top {
        height: 52px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        .title {
          display: flex;
          align-items: center;
          img {
            width: 26px;
            height: 26px;
            margin-left: 10px;
            margin-right: 20px;
          }
          span {
            font-size: 20px;
            font-weight: bold;
            color: #343434;
          }
        }
        img {
          width: 22px;
          height: 12px;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
